import React from "react";

function ImageView({element}) {
  return (
    <img
      draggable="false"
      style={{
        pointerEvents: "none",
      }}
      src={element?.value}
      alt={element?.value}
      className={(element.className || "") }
      crossOrigin="anonymous"
      >
    </img>
  );
}

export default ImageView;
